// Mock AuthService
export default {
  login: (username, password) => Promise.resolve({ token: 'mock-token', user: { username } }),
  logout: () => Promise.resolve(),
  getUser: () => Promise.resolve({ username: 'mockUser' })
};

